export default function renderInline(item, key) {
  if (item == null) return null;

  if (typeof item === "string" || typeof item === "number") {
    return <span key={key}>{item}</span>;
  }

  if (typeof item === "object") {
    if (item.italic) {
      return <em key={key}>{item.italic}</em>;
    }
    if (item.bold) {
      return <strong key={key}>{item.bold}</strong>;
    }
    if (item.underline) {
      return (
        <span key={key} style={{ textDecoration: "underline" }}>
          {item.underline}
        </span>
      );
    }
  }

  return null;
}